import { getSource } from "@/api/file";
import axios from "axios";
import dayjs from "dayjs";

export function getTime(arr) {
  if (arr) {
    return dayjs(arr).format("YYYY-MM-DD HH:mm:ss");
  } else {
    return "--";
  }
}

export function getDate(arr) {
  if (arr) {
    return dayjs(arr).format("YYYY-MM-DD");
  } else {
    return "--";
  }
}

export function getNowTime(date = new Date(), type = 1) {
  let Y, M, D, h, m, s;
  (Y = date.getFullYear() + ""),
    (M =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1),
    (D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
  if (type === 2) {
    (h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()),
      (m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()),
      (s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
  }

  return type === 1
    ? `${Y}年${M}月${D}日`
    : `${Y}年${M}月${D}日  ${h}时${m}分${s}秒`;
}

/**
 * 隐藏字符串内某段字符，如隐藏手机号
 * @param str
 * @param startIndex
 * @param mosaicLength
 * @param emptyText
 * @returns {string|Error}
 */
export function genStringMosaic(str, startIndex, mosaicLength, emptyText = "") {
  if (!str) return emptyText;
  if (typeof startIndex !== "number" && typeof mosaicLength !== "number") {
    return str;
  }
  if (startIndex > str.length || startIndex + mosaicLength > str.length) {
    return str;
  }
  const sliceLeft = str.slice(0, startIndex);
  const sliceRight = str.slice(startIndex + mosaicLength, str.length);
  return `${sliceLeft}${"*".repeat(mosaicLength)}${sliceRight}`;
}

/**
 * 邮箱的马赛克封装
 * @param isNeedGenMosaic
 * @param str
 * @param emptyText
 * @returns {string|Error|*}
 */
export function genEmailMosaic(isNeedGenMosaic, str, emptyText = "") {
  if (!isNeedGenMosaic) {
    return genStringMosaic(str, 0, 0, emptyText);
  }
  // 查找@字符下标
  const index = str.indexOf("@");
  if (index < 4) {
    return str;
  } else {
    // @前面的字符长度为3则不打码
    const START_MOSAIC_INDEX = 3;
    return genStringMosaic(
      str,
      START_MOSAIC_INDEX,
      index - START_MOSAIC_INDEX,
      emptyText
    );
  }
}

/**
 * 用户姓名的马赛克封装
 * @param isNeedGenMosaic
 * @param str
 * @param emptyText
 * @returns {string|Error|*}
 */
export function genUserNameMosaic(isNeedGenMosaic, str, emptyText = "") {
  if (!isNeedGenMosaic) {
    return genStringMosaic(str, 0, 0, emptyText);
  }
  return genStringMosaic(str, 0, str.length - 1, emptyText);
}

/**
 * 用户手机号的马赛克封装
 * @param isNeedGenMosaic
 * @param str
 * @param emptyText
 * @returns {string|Error|*}
 */
export function genUserPhoneMosaic(isNeedGenMosaic, str, emptyText = "") {
  if (!isNeedGenMosaic) {
    return genStringMosaic(str, 0, 0, emptyText);
  }
  return genStringMosaic(str, 3, 4, emptyText);
}

/**
 * 检查是否是身份证号
 * @param str
 * @returns {boolean}
 * @constructor
 */
export function isIdCard(str) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str);
}

/**
 * 简单的邮箱格式正则检查
 * @param str
 * @returns {boolean}
 */
export function isEmail(str) {
  return /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(str);
}

/**
 * 姓名正则
 * @description 判断中英文姓名、少数民族(支持中间·)、空格
 * @param str
 * @returns {boolean}
 */
export function isFullName(str) {
  return /^[\u4E00-\u9FA5A-Za-z\s]+(·[\u4E00-\u9FA5A-Za-z]+)*$/.test(str);
}

/**
 * 中国手机号检查
 * @param str
 * @returns {boolean}
 */
export function isMobilePhone(str) {
  return /^1[123456789]\d{9}$/.test(str);
}

/**
 * 函数节流
 * @param func
 * @param delay
 * @returns {(function(): void)|*}
 */
export function throttle(func: Function, delay: number) {
  let timer: NodeJS.Timeout | null = null;
  return function (this: unknown, ...args: unknown[]) {
    if (!timer) {
      func.apply(this, args);
      timer = setTimeout(() => {
        timer = null;
      }, delay);
    }
  };
}

/**
 * 数组去重
 * @param array
 * @returns {*}
 */
export function clearArrayRepeat(array) {
  if (!Array.isArray(array)) return array;
  return array.filter((item, index, arr) => arr.indexOf(item, 0) === index);
}

/**
 * 将一维数组对象转化为以指定key的对象
 * 主要用于优化for循环嵌套O(n**2) => O(n) + O(n)
 * @param arr
 * @param keyName
 * @returns {{}}
 */
export function arrayConvertObject(arr, keyName) {
  if (!Array.isArray(arr)) return arr;

  const map = {};
  for (const item of arr) {
    if (!map[item[keyName]]) {
      map[item[keyName]] = item;
    }
  }

  return map;
}

/**
 * 对象深拷贝
 * @param target
 */
export function deepClone(target) {
  if (typeof target !== "object") return target;

  let obj;
  if (Array.isArray(target)) {
    obj = [];
  } else {
    obj = {};
  }
  for (let prop in target) {
    // obj.hasOwnProperty 判断某个对象是否含有指定的属性
    // 该方法会忽略掉从原型链上继承的属性
    if (target.hasOwnProperty(prop)) {
      if (typeof target === "object") {
        obj[prop] = deepClone(target[prop]);
      } else {
        obj[prop] = target[prop];
      }
    }
  }
  return obj;
}

export function convertHttpUrlHeader(url) {
  const newUrl = url;
  const { protocol } = window.location;
  const HTTPS = "https";
  const HTTPS_REG = /https/;
  const HTTP_REG = /http/;
  // 若域名为https而返回的url为http则手动替换为https
  if (HTTPS_REG.test(protocol)) {
    newUrl.replace(HTTP_REG, HTTPS);
  }

  return newUrl;
}

/**
 * dataUrl转File
 * @param dataUrl
 * @param fileName
 */
export function dataUrlToFile(dataUrl, fileName) {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}

/**
 * 下载文件
 * @param fileId
 * @param fileName
 */
export function downloadFile(fileId, fileName?) {
  if (!fileId) return;
  getSource(fileId).then(async (res) => {
    if (res.data?.length) {
      downloadFileByUrl(res.data[0].fileUrl, fileName);
    } else {
    }
  });
}

export async function downloadFileByUrl(fileUrl: string, fileName?: string) {
  const { data } = await axios.get(fileUrl, {
    responseType: "blob",
  });
  let a = document.createElement("a");
  const url = window.URL.createObjectURL(data);
  a.href = url;
  a.download =
    fileName || (decodeURI(fileUrl).split("?")[0].split("/").pop() as string);
  a.click();
  window.URL.revokeObjectURL(url);
}

/**
 * chunk(['a', 'b', 'c', 'd'], 2)
 * // => [['a', 'b'], ['c', 'd']]
 *
 * chunk(['a', 'b', 'c', 'd'], 3)
 * // => [['a', 'b', 'c'], ['d']]
 */
export function chunk(array, size = 1) {
  size = Math.max(Number(size), 0);
  const length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  let index = 0;
  let resIndex = 0;
  const result = new Array(Math.ceil(length / size));

  while (index < length) {
    result[resIndex++] = slice(array, index, (index += size));
  }
  return result;
}

/**
 * var array = [1, 2, 3, 4]
 *
 * _.slice(array, 2)
 * // => [3, 4]
 */
export function slice(array, start, end) {
  let length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  start = start == null ? 0 : start;
  end = end === undefined ? length : end;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : (end - start) >>> 0;
  start >>>= 0;

  let index = -1;
  const result = new Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

export function uuid() {
  const s: any[] = [];
  const hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  return s.join("");
}

export const storageGet = (key: string): any => {
  const data = localStorage.getItem(key);

  if (data) {
    try {
      return JSON.parse(data).value;
    } catch (error: any) {
      console.warn(error);
    }
  }
  return data;
};

export const storageSet = (key: string, value: any): any => {
  localStorage.setItem(key, JSON.stringify({ type: typeof value, value }));
};

export const storageRemove = (key: string) => {
  localStorage.removeItem(key);
};

export const storageClear = () => {
  localStorage.clear();
};

export const getFileType = (filePath) => {
  const startIndex = filePath.lastIndexOf(".");
  if (startIndex != -1)
    return filePath.substring(startIndex + 1, filePath.length).toLowerCase();
  return "";
};
